import React from 'react'
import { cn } from '@/lib/cn'

type SectionProps = {
  id?: string
  tone?: 'default' | 'muted' | 'none'
  children: React.ReactNode
  className?: string
}

export function Section({ id, tone = 'default', children, className }: SectionProps) {
  const getBackgroundClass = () => {
    switch (tone) {
      case 'muted': return 'bg-bg-subtle'
      case 'none': return ''
      default: return 'bg-white'
    }
  }

  return (
    <section
      id={id}
      className={cn(
        'py-20 md:py-28',
        getBackgroundClass(),
        className
      )}
    >
      <div className="w-full max-w-[1100px] mx-auto px-4 md:px-6">{children}</div>
    </section>
  )
}
